import Api from '@/api'

const state = {
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalCount: 0
}
const getters = {
    channels: state => state.items,
    cPageNo: state => state.pageNo,
    cPageSize: state => state.pageSize,
    cTotalPage: state => state.totalPage,
    cTotalCount: state => state.totalCount
}
const mutations = {}
const actions = {
    async channelList({state}, params) {
        let {data} = await Api.channelList(params);
        let {pageNo, pageSize, totalCount, totalPage, items} = data;
        state.pageNo = pageNo;
        state.pageSize = pageSize;
        state.totalCount = totalCount;
        state.items = items;
        state.totalPage = totalPage
    },
    async channelSave({state}, params) {
        return Api.channelSave(params);
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/components/channel_store.js